import { render, staticRenderFns } from "./profileComponent.vue?vue&type=template&id=1a86afab&scoped=true"
import script from "./profileComponent.vue?vue&type=script&lang=js"
export * from "./profileComponent.vue?vue&type=script&lang=js"
import style0 from "./profileComponent.vue?vue&type=style&index=0&id=1a86afab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a86afab",
  null
  
)

export default component.exports